import React from 'react';
import { useTranslation } from 'react-i18next';
import { InformationPopup } from '../../ui/InformationPopup';

export const ReloadPageAlert: React.FC = () => {
  const { t } = useTranslation();

  const reloadPage = () => window.location.reload();

  return (
    <InformationPopup
      modalId="reload-page-alert"
      isOpen={true}
      title={t('pages.current_item.reload_page_alert.title')}
      message={t('pages.current_item.reload_page_alert.message')}
      declineButtonText={t('pages.current_item.reload_page_alert.button')}
      onDeclineHandlerClick={reloadPage}
    />
  );
};
